import { styled } from 'goober';
import Modal from './Modal';
import CustomButton from './CustomButton';
import { Fragment } from 'preact';
import { useState } from 'preact/hooks';
import Checkbox from 'preact-material-components/Checkbox';
import 'preact-material-components/Checkbox/style.css';
import {
  useCheckoutContext,
  useCheckoutDispatchContext,
} from '../../storeProviders/checkoutWidgetStore';

const CancelContainer = styled('div')`
  .buttonsContainer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 250px;
    margin: 0px auto;
  }
  .reasonButtonsContainer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 250px;
    margin: 20px auto 40px;
  }
  .infoIcon {
    width: fit-content;
    color: orange;
    margin: 0px auto 10px;
    font-size: 30px;
  }
  .cancelText {
    font-weight: 500;
    font-size: 20px;
    line-height: 24px;
    color: #003c7c;
    margin: 0 auto 10px;
    max-width: 250px;
  }
  .confirmButton {
    background-color: #d9d9d9 !important;
    color: #000000 !important;
    width: 110px !important;
    height: 20px !important;
    border-radius: 5px !important;
    font-size: 18px !important;
  }
  .cancelButton {
    width: 110px !important;
    height: 20px !important;
    border-radius: 5px !important;
    font-size: 18px !important;
  }
  .checkBoxContainer {
    display: flex;
    align-items: flex-start;
    padding: 5px 0;
  }
  .reasonHeader {
    font-weight: 600;
    font-size: 20px;
    line-height: 1.5;
    color: #003c7c;
    max-width: 265px;
    margin: 50px auto 10px;
  }
  .reasonText {
    padding-top: 9px;
    line-height: 1.5;
  }
  .modalBox {
    max-width: 395px;
    width: 95%;
    background-color: #ffffff;
    padding: 30px 10px;
    line-height: 0;
    border-radius: 15px !important;
    animation: openModal 0.2s ease-out forwards;
    @keyframes openModal {
      0% {
        transform: scale(0.5);
      }
      100% {
        transform: scale(i);
      }
    }
  }
  .outerModalClass {
    top: 140px !important;
    transform: translate(-50%, 0%) !important;
  }
`;

const CancelModal = (props) => {
  const cancellationReasons = [
    'Don’t want to purchase anymore',
    'Not comfortable sharing personal details',
    'OTP not received',
    'Will use other payment methods',
    'Others',
  ];
  const [selectedReason, setSelectedReason] = useState('');
  const [showReasonsScreen, setShowReasonScreen] = useState(false);
  const checkoutState = useCheckoutContext();
  const checkoutDispatch = useCheckoutDispatchContext();
  return (
    <CancelContainer>
      <Modal
        open
        className='modalBox'
        outerModalClass={showReasonsScreen ? '' : 'outerModalClass'}
        withCrossIcon={false}
        disableBackdropClick={true}
      >
        {showReasonsScreen ? (
          <Fragment>
            <div className='reasonHeader'>
              Why do you want to cancel the payment?
            </div>
            {cancellationReasons.map((reason, index) => {
              return (
                <div className='checkBoxContainer'>
                  <Checkbox
                    id={`basic-checkbox-${index}`}
                    ref={(cb) => {
                      this.cb = cb;
                    }}
                    checked={selectedReason === reason}
                    onChange={() => {
                      setSelectedReason(reason);
                    }}
                  />
                  <label
                    for={`basic-checkbox-${index}`}
                    id={`basic-checkbox-label-${index}`}
                    className='reasonText'
                  >
                    {reason}
                  </label>
                </div>
              );
            })}
            <div className='reasonButtonsContainer'>
              <CustomButton
                name='Cancel'
                className='confirmButton'
                onClick={() => {
                  checkoutDispatch({
                    type: 'STORE_STATE',
                    payload: {
                      closeIconConfig: {
                        ...checkoutState.closeIconConfig,
                        showCancellationPopup: false,
                      },
                    },
                  });
                }}
              />
              <CustomButton
                name='Confirm'
                className='cancelButton'
                onClick={() => {
                  checkoutDispatch({
                    type: 'SEND_MESSAGE',
                    payload: {
                      payload: 'payload',
                      signature: 'signature',
                      actionName: 'onTransactionComplete',
                    },
                  });
                }}
              />
            </div>
          </Fragment>
        ) : (
          <Fragment>
            <div class='material-icons infoIcon'>info</div>
            <div className='cancelText'>
              Are you sure you want to cancel the payment?
            </div>
            <div className='buttonsContainer'>
              <CustomButton
                name='Yes'
                className='confirmButton'
                onClick={() => {
                  setShowReasonScreen(true);
                }}
              />
              <CustomButton
                name='No'
                className='cancelButton'
                onClick={() => {
                  checkoutDispatch({
                    type: 'STORE_STATE',
                    payload: {
                      closeIconConfig: {
                        ...checkoutState.closeIconConfig,
                        showCancellationPopup: false,
                      },
                    },
                  });
                }}
              />
            </div>
          </Fragment>
        )}
      </Modal>
    </CancelContainer>
  );
};
export default CancelModal;



// WEBPACK FOOTER //
// ./components/checkoutWidget/CancelModal.js